import React from 'react';
import Link from 'next/link';
import THLogoUrl from '../../assets/footer-svgs/logo-white.svg?url';
import Copyright from '../Copyright';
import s from './HomeFooter.module.scss';
import Image from 'next/image';
import RichText from '../RichText';
import { Description } from '../../constants/types';

interface HomeFooterProps {
  footerDescription?: Description | null;
}

const HomeFooter: React.FC<HomeFooterProps> = ({ footerDescription }) => {
  return (
    <footer className={s.root}>
      <div className={s.footerTop}>
        <div className={s.container}>
          <div className={s.footerRow}>
            <div className={s.footerLogo}>
              <div className={s.footerLogoImg}>
                <Image src={THLogoUrl} alt='Tech Holding Logo' data-testid="THLogo"/>
                  {footerDescription && 'root' in footerDescription && footerDescription.root && <RichText data={footerDescription} />}
              </div>
            </div>
            <div className={s.footerMenu}>
              <h5>Company</h5>
              <ul className={s.footerMenuList}>
                <li className={s.footerMenuItem}>
                  <Link href="/about">About Us</Link>
                </li>
                <li className={s.footerMenuItem}>
                  <Link href="/services">What We Do</Link>
                </li>
                <li className={s.footerMenuItem}>
                  <Link href="/work">Case Studies</Link>
                </li>
                <li className={s.footerMenuItem}>
                  <Link href="/blog">Blog</Link>
                </li>
                <li className={s.footerMenuItem}>
                  <Link href="/careers">Careers</Link>
                </li>
                <li className={s.footerMenuItem}>
                  <Link href="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className={s.footerLine} />
          <div className={s.copyrightContainer}>
            <Copyright />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
